import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CurrencyText } from '../input-formatters/CurrencyText';

const AgGridCashBalanceChipCell = ({
  value,
  data,
  node,
  onlyColortoFirstRow = false,
  disableChipStyles = false
}: ICellRendererParams & {
  onlyColortoFirstRow?: boolean;
  disableChipStyles?: boolean;
}) => {
  if (value === null || value === undefined) {
    return <></>;
  }
  const displayAmount = parseFloat(value?.toFixed(2));
  let color: ChipProps['color'] = 'default';
  if (onlyColortoFirstRow) {
    color = node.rowIndex === 0 ? (displayAmount > 0 ? 'success' : 'error') : 'default';
  } else {
    color = displayAmount > 0 ? 'success' : 'error';
  }
  return (
    <Chip
      color={color}
      label={<CurrencyText value={displayAmount} />}
      size="small"
      variant="light"
      sx={{
        ...(disableChipStyles && {
          backgroundColor: 'transparent !important'
        })
      }}
    />
  );
};

export default AgGridCashBalanceChipCell;
